export const xsBreakpoint = 560;

export const lgBreakpoint = 1380;
